export default __webpack_public_path__ + "static/amotz-81d0ee197f76b5416d48611e3a8f7de9.png";